import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3125InvoiceLineGridRow } from "../../../../U3125Service";
import type { U3125InvoiceLineHandlerReturn } from "./U3125InvoiceLineHandlers";

interface U3125InvoiceLineDeleteDlgProps {
  u3125InvoiceLineHandler: U3125InvoiceLineHandlerReturn;
  t: TFunction;
  NS: string;
}

function U3125InvoiceLineDeleteDlg({ u3125InvoiceLineHandler, t, NS }: U3125InvoiceLineDeleteDlgProps) {
  if (!u3125InvoiceLineHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={u3125InvoiceLineHandler.isDeleteDialogOpen}
      onClose={u3125InvoiceLineHandler.onDlgDeleteClose}
      title={t("sectionInvoiceLines", { ns: NS })}
    >
      <p className="mb-4">
        {t("msgDeleteInvoiceLines", {
          count: u3125InvoiceLineHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3125InvoiceLineHandler.gridStateHandlers.getSelectedRows().map((row: U3125InvoiceLineGridRow, index: number, array: U3125InvoiceLineGridRow[]) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.description?.slice(0, 40) ?? ""}${(row.description?.length ?? 0) > 40 ? "…" : ""}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3125InvoiceLineDeleteDlg;
